import {block} from '../../../utils/cn';

import './ListItemView.scss';

export const b = block('list-item-view');
